// removed by extract-text-webpack-plugin
module.exports = {"title":"HeaderTitle__title___2-RbP"};